
export const supportareaPageNamesMap = {
    '/mybooking/support-area/flights': 'mybooking',
    '/mybooking/support-area/hotels': 'mybooking',
    '/mybooking/support-area/trains': 'mybooking',
    '/mybooking/support-area/missing_info': 'mybooking',
    '/mybooking/support-area/no-log': 'mybooking',
    '/mybooking/additional-services': 'mybooking',
    '/mybooking/manage-booking-not-managed-by-edo': 'mybooking',
    '/mybooking/hotels/chatbot': 'mybooking',
    '/mybooking/hotels/property-contact-details': 'mybooking',
    '/mybooking/hotels/other-requests': 'mybooking',
    '/mybooking/booking-documentation': 'mybooking',
    '/mybooking/confirmation-email': 'mybooking',
};
